/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateDomainRequestBody,
  UpdateDomainRequestBody$Outbound,
  UpdateDomainRequestBody$outboundSchema,
} from "../components/updatedomainrequestbody.js";

export type UpdateDomainSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateDomainRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateDomainRequestBody: UpdateDomainRequestBody;
};

/** @internal */
export type UpdateDomainSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateDomainSecurity$outboundSchema: z.ZodMiniType<
  UpdateDomainSecurity$Outbound,
  UpdateDomainSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateDomainSecurityToJSON(
  updateDomainSecurity: UpdateDomainSecurity,
): string {
  return JSON.stringify(
    UpdateDomainSecurity$outboundSchema.parse(updateDomainSecurity),
  );
}

/** @internal */
export type UpdateDomainRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateDomainRequestBody: UpdateDomainRequestBody$Outbound;
};

/** @internal */
export const UpdateDomainRequest$outboundSchema: z.ZodMiniType<
  UpdateDomainRequest$Outbound,
  UpdateDomainRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    updateDomainRequestBody: UpdateDomainRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      updateDomainRequestBody: "UpdateDomainRequestBody",
    });
  }),
);

export function updateDomainRequestToJSON(
  updateDomainRequest: UpdateDomainRequest,
): string {
  return JSON.stringify(
    UpdateDomainRequest$outboundSchema.parse(updateDomainRequest),
  );
}
